exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.required-field>label[data-v-8b110ac8]::after {\n    content: \"*\";\n    color: red;\n    margin-left: 0.25rem;\n}\n.form-control-feedback[data-v-8b110ac8] {\n    font-weight: 100;\n    color: red;\n    position: initial;\n    text-align: left;\n    height: auto;\n    width: auto;\n}\n.has-danger[data-v-8b110ac8] {\n    color: red;\n}\n.mt[data-v-8b110ac8] {\n    margin-top: 7px;\n}\n.gradientbt[data-v-8b110ac8] {\n    background: #0f6940;\n    color: white;\n}\n.inputwrapper[data-v-8b110ac8] {\n    position: relative;\n}\n.maps[data-v-8b110ac8] {\n    position: absolute;\n    top: 7px;\n    right: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-8b110ac8","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/wasteRecycle/wasteRecycleCreate.vue
// module id = 216
// module chunks = 0